import { faPencil, faEllipsis, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger
} from '@/ui';

interface Props {
  onTransitionClick: () => void;
  onCorrectionClick: () => void;
  transitionDisabled: boolean;
  correctionDisabled: boolean;
  className?: string;
}

export const ActionButtons = ({
  onTransitionClick,
  onCorrectionClick,
  transitionDisabled,
  correctionDisabled,
  className
}: Props) => {
  return (
    <div className={className}>
      <div className="flex flex-row items-center gap-1">
        <Button
          aria-label="Transition to a new phase"
          color="neutral"
          variant="outline"
          onClick={() => onTransitionClick()}
          size="icon-md"
          type="button"
          disabled={transitionDisabled}>
          <FontAwesomeIcon icon={faPencil} />
        </Button>

        <DropdownMenu>
          <DropdownMenuTrigger>
            <Button
              aria-label="Open dropdown"
              color="neutral"
              variant="outline"
              size="icon-md"
              type="button">
              <FontAwesomeIcon icon={faEllipsis} />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent side="bottom" align="end">
            <div className="px-4 py-2 uppercase font-bold text-gray-400 text-sm">Advanced</div>
            <DropdownMenuItem
              disabled={correctionDisabled}
              onClick={() => onCorrectionClick()}
              className="gap-4 justify-center">
              <FontAwesomeIcon
                className="text-red-600 mt-0.5 shrink-0"
                icon={faTriangleExclamation}
              />
              <div>
                <div className="text-sm font-semibold text-red-700">Phase Correction</div>
                <div className="text-xs text-gray-500">Do not use for Phase change or creation</div>
              </div>
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </div>
  );
};
